/* eslint-disable react/require-default-props */
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Proptypes from "prop-types";
import * as actions from "../actions/default";
import * as apiActions from "../api/index";
import { showElement, selectOption } from "./SelectOption";
import { dynamicRow } from "../../Transactions/utils/dynamicRow";
import headerRenderers from "../columns/headerRenderers";

const mapStateToProps = (state) => ({
  source: state.leadIndex.from,
});

const LeadHeadersDynamic = ({ source, renderableColumns }) => {
  const [orderBy, setorderBy] = useState("");
  const [orderDirection, setorderDirection] = useState("");
  const [getcall, setgetcall] = useState(false);

  const getPeople = () => {
    showElement(document.getElementsByClassName("loading-overlay")[0]);
    selectOption("select-none");
    let url = "/people/all_people";
    url = window.Brivity.addParameter(window.location.href, "order_by", `${orderBy}+${orderDirection}`);
    url = window.Brivity.addParameter(url, "order_scope", "");
    window.Turbolinks.cacheCurrentPage();
    window.Turbolinks.visit(url);
  };

  useEffect(() => {
    if (!getcall && orderBy && orderDirection) {
      getPeople();
    } else if (!getcall) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (params.order_by) {
        const getorder = params.order_by.split(" ");
        const direction = getorder.pop();
        const orderbyname = getorder.join(" ");
        if (direction && orderbyname) {
          setgetcall(true);
          setorderBy(orderbyname);
          setorderDirection(direction);
        }
      }
    }
  }, [orderBy, orderDirection]);

  const orderByname = (valueToOrderBy) => {
    if (orderBy !== valueToOrderBy) {
      setorderDirection("desc");
    } else {
      setorderDirection(orderDirection === "desc" ? "asc" : "desc");
    }
    setorderBy(valueToOrderBy);
    setgetcall(false);
  };
  const selectedArrow = (name, direction) => {
    if (name === orderBy && direction === orderDirection) {
      return "selected";
    }
    return "";
  };

  const keyedCells = headerRenderers({ orderByname, selectedArrow, source });
  const columns = renderableColumns ? dynamicRow(renderableColumns, keyedCells) : null;

  return (
    <thead className="people-header">
      <tr>{columns}</tr>
    </thead>
  );
};
LeadHeadersDynamic.propTypes = {
  source: Proptypes.string,
  renderableColumns: Proptypes.shape({}),
};
LeadHeadersDynamic.defaultProps = {
  source: null,
  renderableColumns: null,
};
export default connect(mapStateToProps, { ...actions, ...apiActions })(LeadHeadersDynamic);
